import React from 'react';
import packageData from '../../../../package.json';
import { Alert } from 'reactstrap';
import { config } from "../../../config";
import { useSelector } from 'react-redux';
import parse from 'html-react-parser';

const Footer = () => {
    const uid = useSelector((state) => state.identityReducer.identity ? state.identityReducer.identity.uid : null)

    return (
        <>
            {
                ( uid === null || Notification.permission === 'granted' || config.push_notification.enabled === false )
                    ? <></>
                    : <Alert color="danger" style={{marginBottom: 0, borderBottom: '1px solid #cf9897', textAlign: 'center'}}>
                        Enable push notification in your browser or application will not work properly!
                    </Alert>
            }
            <footer className="footer text-center">
                { parse(config.instance.name_notag) } v. {packageData.version} - Designed and Developed by {' '}
                <a href={packageData.author.url} target="_blank" rel="noopener noreferrer">{packageData.author.name}</a>.
            </footer>
        </>
    );
}
export default Footer;
